import {
  Buckets,
  Client,
  Database,
  JSONSchema,
  Collection,
  ThreadID,
  UserAuth,
  PushPathResult
} from '@textile/hub'
import { v4 as uuid } from 'uuid'
import { Where } from '@textile/threads'
import { Libp2pCryptoIdentity } from '@textile/threads-core'

const projectPath = (id: string) => ``
const bucketKey = 'bafzbeihhgz6wz54sto66arwm7e2wmdemjjplemsoewcr37ydebgbaz7uoi' //'bafzbeiho6l2pa6g76nnrheqrqazb4opdhj32yc3xzhbke4dguelahrucki'
const ipfsPath =
  '/ipfs/bafybeifpam3big456infpkmukzgwqy2hz64iy72u762pmyo2bxfjbx3gxm'

const threadID = ThreadID.fromString(
  // 'bafkrlbs43ifiwxwgwlslealcolhqeyjjalytvx4krhzkuy6k27fzika'
  'bafkvfap5eu6agaxejq2sxa7wuhacgokmv44izprmkhvvnzt4bbvnmiq'
)
const collectionName = 'projectIndizies'
const bucketName = 'boxtronik-projects'
const threadName = ''

const schema: JSONSchema = {
  $id: '',
  $schema: 'http://json-schema.org/draft-07/schema#',
  // definitions: {
  //   ProjectIndex: {
  title: 'ProjectIndex',
  type: 'object',
  required: ['_id', 'user', 'path'],
  properties: {
    _id: {
      type: 'string',
      description: "The instance's id."
    },
    user: {
      type: 'string'
    },
    path: {
      type: 'string'
    },
    createdAt: {
      type: 'number'
    },
    updatedAt: {
      type: 'number'
    }
  }
  //   }
  // }
}

const indizies = [
  { path: 'id', unique: true },
  { path: 'user', unique: false }
  // { path: 'bucketKey', unique: true }
]

type TextileServiceConstructorParams =
  | UserAuth
  | (() => UserAuth | Promise<UserAuth>)

class TextileService {
  constructor(userAuth?: TextileServiceConstructorParams) {
    if (typeof userAuth === 'function') {
    }
  }
  #userAuth?: UserAuth
  #userIdentity?: Libp2pCryptoIdentity
  #threadClient?: Client
  #database?: Database
  #bucketClient?: Buckets
  #indexCollection?: Collection<{ [key in '_id' | 'path' | 'user']: string }>

  #setupIndexCollection = async () => {
    if (!this.#threadClient || !this.#database) {
      console.warn('no client')
      return
    }
    try {
      await this.#threadClient.newCollection(
        threadID,
        collectionName,
        schema
        // indizies
      )
      const indexCollection = this.#database.collections.get(collectionName)
      this.#indexCollection = indexCollection
    } catch (error) {
      console.warn(error)
    } finally {
      return this.#indexCollection
    }
    // return indexCollection
  }

  get indexCollection() {
    if (!this.#indexCollection) this.#setupIndexCollection()
    return this.#indexCollection
  }

  #openBucket = async () => {
    if (!this.#userAuth || !this.#userIdentity) {
      console.warn('No Credentials in ThreadService')
      return
    }
    const bucketsClient = Buckets.withUserAuth(this.#userAuth)
    bucketsClient.context.withThread(threadID.toString())
    await bucketsClient.open(bucketName, '', false, threadID.toString())
    this.#bucketClient = bucketsClient
  }

  close = async () => {
    this.#userAuth = undefined
    this.#userIdentity = undefined
    this.#threadClient = undefined
    this.#bucketClient = undefined
    this.#userIdentity = undefined
    this.#indexCollection = undefined
    this.#database = undefined
  }

  init = async (userAuth: UserAuth, userIdentity: string) => {
    this.#userAuth = userAuth
    this.#userIdentity = await Libp2pCryptoIdentity.fromString(userIdentity)
    console.log('TEXTILE ', this.#userIdentity.public.toString())
    this.#threadClient = Client.withUserAuth(userAuth)
    await this.#openBucket()

    await this.#threadClient.updateCollection(
      threadID,
      collectionName,
      schema
      // indizies
    )

    // const projectData = {
    //   id: uuid(),
    //   someData: 'string data',
    //   bal: 'bol',
    //   createdAt: new Date().toLocaleDateString()
    // }

    // const savedProject = await this.saveProject(projectData)

    // const indexes = await this.#threadClient.find(threadID, collectionName, {})
    // const i1 = '1595719160404'
    // // const i2 = '1595719140366'

    // const q = new Where('user').eq('test')

    // const vals = await this.#threadClient.create(threadID, collectionName, [
    //   { _id: new Date().valueOf().toString(), path: '/', user: 'tast' }
    // ])

    // const values = await this.#threadClient.find(threadID, collectionName, {})

    // const query = await this.#threadClient.find(threadID, collectionName, q)

    // const project = await this.#threadClient?.findByID(
    //   threadID,
    //   collectionName,
    //   i1
    // )

    // this.#threadClient.has(threadID, collectionName)

    // this.#database = db
    // db.collections
    // console.log(db)

    // if (!this.#database.collections.get(collectionName))
    //   this.#setupIndexCollection()

    // return {
    //   buckets: this.#bucketClient,
    //   thread: this.#threadClient,
    //   db: this.#database
    // }
    return this
  }

  #writeToBucket = async (
    { path, data }: { path: string; data: { id: string } & any },
    retryCount: number = 0
  ): Promise<PushPathResult | undefined> => {
    if (!this.#bucketClient) {
      console.warn('Bucket not initiated')
      return
    }
    const buf = Buffer.from(JSON.stringify(data, null, 2))
    let result
    try {
      result = await this.#bucketClient.pushPath(bucketKey, path, buf, {
        progress: (prog) => {
          console.log(`Progress: ${prog}`)
        }
      })
    } catch (error) {
      console.warn(`Not saved Project ${data.id}!`)
      // Retry
      if (retryCount < 3) {
        await this.#openBucket()
        result = await this.#writeToBucket(data, ++retryCount)
      }
    }
    return result
  }

  #readFromBucket = async (path: string) => {
    if (!this.#bucketClient) {
      console.warn('Bucket not initiated')
      return
    }

    let data: any
    try {
      const ita = await this.#bucketClient?.pullPath(bucketKey, path)

      if (!!ita) {
        const value = await collectUint8Arrays(ita)
        let str = ''
        for (var i = 0; i < value.length; i++) {
          str += String.fromCharCode(parseInt(value[i] as any))
        }
        data = JSON.parse(str)
      }
    } catch (error) {
      console.warn('Read from bucket Error', error)
      data = undefined
    }

    return data
  }

  async saveProject(data: { id: string } & any) {
    if (!this.#bucketClient) {
      console.warn('Bucket not initiated')
      return
    }
    const result = await this.#writeToBucket({
      data,
      path: `${data.id}/project.json`
    })
    if (!!result) {
      this.indexProject({
        id: data.id,
        path: result.path.path,
        user: this.#userIdentity?.toString() || 'anonymous'
      })
    }
    return result
  }

  async saveEditor(data: { id: string; draft: string } & any) {
    if (!this.#bucketClient) {
      console.warn('Bucket not initiated')
      return
    }
    return await this.#writeToBucket({
      data,
      path: `${data.draft}/editor.json`
    })
  }

  async updateProject(data: { id: string; updatedAt: number }) {
    if (!this.#bucketClient) {
      console.warn('Bucket not initiated')
      return
    }
    const result = await this.#writeToBucket({
      data,
      path: `${data.id}/project.json`
    })
    if (!!result) {
      this.updateIndexProject({
        id: data.id,
        updatedAt: data.updatedAt,
        path: result.path.path
      })
    }
  }

  async indexProject({
    id,
    path,
    user,
    createdAt,
    updatedAt
  }: { [key in 'id' | 'path' | 'user']: string } &
    { [key in 'createdAt' | 'updatedAt']?: number }) {
    const indexEntry = await this.#threadClient?.create(
      threadID,
      collectionName,
      [{ _id: id, path, user, createdAt }]
    )
    return indexEntry
  }

  async updateIndexProject({
    id,
    path,
    updatedAt
  }: {
    id: string
    path: string
    updatedAt: number
  }) {
    const data = await this.getProject({ id })
    if (!!data) {
      const value = data.instancesList[0]
      await this.#threadClient?.save(threadID, collectionName, [
        { ...value, path, updatedAt }
      ])
    }
  }

  async isOwner(id: string) {
    if (!this.#userIdentity) {
      console.warn('No Identity')
      return
    }
    const query = new Where('_id')
      .eq(id)
      .and('user')
      .eq(this.#userIdentity.toString())
    const index = await this.#threadClient?.find(
      threadID,
      collectionName,
      query
    )
    if (index?.instancesList?.length) return index?.instancesList?.length > 0
    return false
  }

  async getProjectIndex(id: string) {
    if (!this.#userIdentity) {
      console.warn('No Identity')
      return
    }
    const query = new Where(this.#userIdentity.toString())
    const index = await this.#threadClient?.find(threadID, collectionName, {})
  }

  async getProjectsIndex() {
    if (!this.#userIdentity) {
      console.warn('No Identity')
      return
    }
    const query = new Where(this.#userIdentity.toString())
    const index = await this.#threadClient?.find(threadID, collectionName, {})
    return index
  }

  async getProjects(callback?: any) {
    if (!this.#userIdentity) {
      console.warn('No Identity')
      return
    }
    const query = new Where('user').eq(this.#userIdentity.toString())
    const indizies = await this.#threadClient?.find(
      threadID,
      collectionName,
      query
    )
    if (Array.isArray(indizies?.instancesList)) {
      const paths = await this.#bucketClient?.listPath(bucketKey, '/')
      // console.log(indizies, paths)
      const instances = indizies?.instancesList
      const projects =
        instances &&
        (await Promise.all(
          instances.map(async (entry) => {
            const has = paths?.item?.itemsList.find(
              (item) => item.name === entry._id
            )
            if (!!has) {
              const path = `./${entry._id}/project.json`
              const data = await this.#readFromBucket(path)
              if (callback && typeof callback === 'function') {
                callback(data)
              }
              return data
            } else {
              // console.log(entry._id)
              // await this.#threadClient?.delete(threadID, collectionName, [
              //   entry._id
              // ])
              // console.log(entry._id, 'DELETED')
            }

            /**
             *
             */

            // if (!!data?.someData) {
            //   const path = paths?.item?.itemsList.find(
            //     (item) => item.name === data.id
            //   )
            //   if (path) {
            //     console.log('GOIN TO REMOVE', path)
            //     await this.#bucketClient?.removePath(bucketKey, path.name)
            //     console.log('SUCCESS REMOVING', path)
            //     return null
            //   }
            // }

            return null
          })
        ))

      // const p = projects
      //   ?.map(async (project) => {
      //     if (!!project?.someData) {
      //       const path = paths?.item?.itemsList.find(
      //         (item) => item.name === project.id
      //       )
      //       if (path) {
      //         console.log('GOIN TO REMOVE', path)
      //         await this.#bucketClient?.removePath(bucketKey, path.path)
      //         return null
      //       }
      //     }
      //     return project
      //   })
      //   .filter((proj) => proj !== null)
      return projects?.filter((p) => p !== null)
    }

    return []
  }

  /** */

  async hasProject(id: string) {
    if (!this.#threadClient) {
      console.warn('No THREADS')
      return
    }
    let hasProject = await this.#threadClient?.has(threadID, collectionName, [
      id
    ])
    // try {
    //   hasProject = await this.#threadClient?.has(threadID, collectionName, [id])
    // } catch (err) {
    //   console.warn(err)
    // }
    return hasProject
  }

  async getProject({ id }: { id: string }) {
    const q = new Where('_id').eq(id)
    const projectIndex = await this.#threadClient?.find(
      threadID,
      collectionName,
      q
    )

    // try {
    //   const metadata = this.#bucketClient?.pullPath(bucketKey, 'index.json')
    //   const { value } = await metadata.next();
    //   let str = "";
    //   for (var i = 0; i < value.length; i++) {
    //     str += String.fromCharCode(parseInt(value[i]));
    //   }
    //   const index: GalleryIndex = JSON.parse(str)
    //   return index
    // } catch (error) {
    //   const index = await this.initIndex()
    //   await this.initPublicGallery()
    //   return index
    // }

    return projectIndex
  }

  pullProject(id: string) {
    if (!this.#bucketClient) throw Error('Bucket not initiated')
    const path = `${id}/project.json`
    this.#bucketClient.pullPath(bucketKey, path)
  }

  get initialized() {
    return !!this.#bucketClient && !!this.#bucketClient
  }

  // saveEditor = async () => {
  //   this.#threadClient?.listDBs()
  //   this.#threadClient?.save(threadID, 'projectChanges', {})
  //   // this.#threadClient?.newCollection(threadID, 'projectChanges', {})
  // }

  // get projects() {
  //   const query = {
  //     $eq: { user: this.#userIdentity }
  //   }
  //   this.#indexCollection.find(query)
  //   return
  // }
}

const textileService = new TextileService()

export { textileService }

async function collectUint8Arrays(
  it: AsyncIterable<Uint8Array>
): Promise<Uint8Array> {
  const chunks = []
  let length = 0
  for await (const chunk of it) {
    chunks.push(chunk)
    length += chunk.length
  }
  if (chunks.length === 1) {
    // No need to copy.
    return chunks[0]
  }
  const collected = new Uint8Array(length)
  let offset = 0
  for (let chunk of chunks) {
    collected.set(chunk, offset)
    offset += chunk.length
  }
  return collected
}
